/** The point nearest a pointer at `fraction` (0..1) of the plot's width, for evenly spaced points; clamped to the ends. */
export function nearestPointIndex(fraction: number, count: number): number | null {
  if (count < 1 || !Number.isFinite(fraction)) return null
  return Math.min(count - 1, Math.max(0, Math.round(fraction * (count - 1))))
}

/** The point a key moves to from `current`, or null for a key that does not move it; no point yet starts at the latest. */
export function steppedPointIndex(key: string, current: number | null, count: number): number | null {
  if (count < 1) return null
  const from = current ?? count - 1
  if (key === 'ArrowLeft' || key === 'ArrowDown') return Math.max(0, from - 1)
  if (key === 'ArrowRight' || key === 'ArrowUp') return Math.min(count - 1, from + 1)
  if (key === 'Home') return 0
  if (key === 'End') return count - 1
  return null
}

/** Which way the readout hangs off its point, so a point near either end keeps it inside the plot. */
export function readoutAlign(xPercent: number): 'start' | 'center' | 'end' {
  if (xPercent < 30) return 'start'
  if (xPercent > 70) return 'end'
  return 'center'
}
